import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { setHamkariDavat, GetHamkariData } from "../axios";
import { useLocation } from "react-router-dom";
import persianToEnglishNumbers from "../tools/farsiToEnglishNumber";

const RegistrationOfCooperation = () => {
  const [formValue, setFormValue] = useState({
    phone: "",
    name: "",
    text: "",
  });

  const changeHandler = ({ target }) => {
    setFormValue((prevState) => {
      return {
        ...prevState,
        [target.name]: target.value,
      };
    });
  };

  const [HamkariData, setHamkariData] = useState({});
  useEffect(() => {
    try {
      GetHamkariData().then(({ data }) => {
        setHamkariData(data[0]);
      });
    } catch (error) {
      console.log(error.message);
    }
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();
    if (
      formValue.name === "" ||
      (formValue.name === "") | (formValue.text === "")
    ) {
      toast.error("پر کردن همه ی فیلد ها الزامیست.");
    } else {
      setHamkariDavat(
        persianToEnglishNumbers(formValue?.phone),
        formValue.name,
        formValue.text
      )
        .then((res) => {
          if (res.data === "1") {
            toast.success(
              <>
                ثبت‌نام شما با موفقیت ثبت شد
                <br />
                <br />
                این وبینار شنبه ۲۵ بهمن ساعت ۲۰ در بستر اسکای روم برگزار می‌شود.
                <br />
                <br />
                لینک و اطلاعات تکمیلی از طریق پیامک برای شما ارسال می‌گردد.
                <br />
                <br />
                توجه داشته باشید که این وبینار ضبط نمی‌گردد و به صورت آنلاین با
                ما همراه باشید.
              </>,
              {
                autoClose: 8000, // milliseconds (8 seconds)
              }
            );
          } else {
            toast.error("ثبت درخواست با مشکل مواجه شد");
          }
        })
        .catch((err) => {
          console.log(err);
        });
      setFormValue({
        phone: "",
        name: "",
        text: "",
      });
    }
  };

  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <div className="shop_area shop_reverse mt-60 mb-60">
      <div className="row">
        <div className=" col-md-12" style={{ float: "none", margin: "auto" }}>
          <div className="container-lg">
            <h4 className="mb-5">ثبت نام وبینار های آتروپین </h4>
            <img
              className="border shadow-sm rounded-2"
              src={HamkariData.aks}
              alt="Moshavereh_aks"
              style={{ height: "100%", width: "100%", objectFit: "fill" }}
            />
          </div>
          <div className="container col-lg-5 col-md-12">
            <p className="mt-2" style={{ whiteSpace: "pre-line" }}>
              {HamkariData.matn}
            </p>
            <div className="mt-4">
              <label>نام</label>
              <input
                type="text"
                onChange={changeHandler}
                id="name"
                name="name"
                value={formValue.name}
                className="form-control"
              />
            </div>
            <div className="mt-4">
              <label>نام خانوادگی </label>
              <input
                type="text"
                onChange={changeHandler}
                id="text"
                name="text"
                value={formValue.text}
                className="form-control"
              />
            </div>
            <div className="mt-4">
              <label>شماره تماس (جهت پیامک شدن لینک وبینار)</label>
              <div style={{ marginTop: "10px" }}>
                <label style={{ color: "red" }}>
                  شماره موبایل حتما باید با کیبورد انگلیسی وارد شود
                </label>
              </div>
              <input
                type="number"
                placeholder="شماره را با 0 و 11 رقم وارد کنید"
                onChange={changeHandler}
                id="phone"
                name="phone"
                value={formValue.phone}
                className="form-control"
              />
            </div>
            <div className="mt-4">
              <button onClick={submitHandler} className="btn btn-success">
                ثبت درخواست
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationOfCooperation;
